import SlideOutButton from "../common/SlideOutButton";
import useReprintAccepted from "../requests/useReprintAccepted";

interface ReprintFailButtonProps {
  stagedOrderId: string;
}

const ReprintFailButton = ({ stagedOrderId }: ReprintFailButtonProps) => {
  const reprintAccepted = useReprintAccepted(stagedOrderId);

  return <SlideOutButton text="Fail Reprint" onClick={() => reprintAccepted.request({ success: false })} />;
}

export default ReprintFailButton;
